module.exports = __webpack_public_path__ + "img/dianshiju.31dc9a22.png";